{
  "noToken": "This link is incomplete. Open the link from the email again.",
  "successActive": "Your email address is confirmed. You can sign in now.",
  "successPendingApproval": "Your email address is confirmed. An administrator now checks your registration; you get an email when your account is ready.",
  "title": "Confirm your email address",
  "toApp": "Continue to sign-in",
  "wait": "Confirming…"
}
